module.exports = __webpack_public_path__ + "img/exam_jan_2025_8wj54edo.d528bbe8.jpg";